const UNRESPONSIVE_TIMEOUT = 35_000;
const runFetch = async (endpoint, body, requestInit) => {
    const response = await fetch(endpoint, {
        ...requestInit,
        headers: requestInit.headers,
        method: 'POST',
        body,
    });
    const newToken = response.headers.get('X-New-Access-Token');
    if (newToken) {
        localStorage.setItem('token', newToken);
    }
    const untypedResult = await response.json();
    if (typeof untypedResult !== 'object' || untypedResult === null || !('success' in untypedResult)) {
        throw new Error(`Unexpected response format from ${endpoint}: ${JSON.stringify(untypedResult)}`);
    }
    return untypedResult;
};
// This should never reject under ordinary circumstances.
// Even if the server can't successfully process the request, it should respond with { success: false, reason: someString }
export const typedFetch = async (endpoint, { body = {}, timeout = UNRESPONSIVE_TIMEOUT, requestInit = {}, } = {}, auth = 'auth') => {
    const token = localStorage.getItem('token');
    if (auth === 'auth' && !token) {
        return { success: false, reason: 'Not logged in' };
    }
    if (token && auth !== 'no-auth') {
        // eslint-disable-next-line no-param-reassign -- Clearer this way
        requestInit.headers = {
            ...requestInit.headers,
            Authorization: `Bearer ${token}`,
        };
    }
    const isFormData = body instanceof FormData;
    return Promise.race([
        runFetch(`/${endpoint}`, isFormData ? body : JSON.stringify(body), {
            ...requestInit,
            headers: isFormData ? requestInit.headers : {
                'content-type': 'application/json',
                ...requestInit.headers,
            },
        }),
        new Promise((resolve) => {
            setTimeout(() => {
                resolve({ success: false, reason: 'Timeout' });
            }, timeout);
        }),
    ]);
};
